import type {SwitchProps as MantineSwitchProps} from '@mantine/core';
import {Switch as MantineSwitch} from '@mantine/core';

export type SwitchProps = MantineSwitchProps;

/**
 * Toggle switch (with `Switch.Group`) — design-layer pass-through over Mantine `Switch`.
 * @registry Pass-through Mantine Switch; import this instead of @mantine/core outside src/design.
 */
export const Switch = MantineSwitch;
